var path = '/pages/seatplans/views/seatplans.tpl.html';
var html = "<div class=\"\" ng-show=\"$state.current.data.view == 'index'\" ui-view=\"index\"></div>\n<div class=\"\" ng-show=\"$state.current.data.view == 'editor'\" ui-view=\"editor\"></div>\n<div class=\"\" ng-show=\"$state.current.data.view == 'details'\" ui-view=\"details\"></div>\n<div class=\"\" ng-show=\"$state.current.data.view == 'elements'\" ui-view=\"elements\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/seatplans/views/seatplans.tpl.html
// module id = 2313
// module chunks = 1